<template>
  <span class="grid-square-suits" v-bind:class="{ 'more-than-one': generalHand.numSpecificHandsInRange > 1 }">
    <!-- more than one -->
    <span
      v-if="generalHand.numSpecificHandsInRange > 1 || numSpecificHandsInRangeVisbile"
      class="more-than-one-text"
    >
      {{ generalHand.numSpecificHandsInRange }}
    </span>

    <!-- suited -->
    <span v-else-if="suitsOfSpecificHandInRange === 'cc'">&clubs;</span>
    <span v-else-if="suitsOfSpecificHandInRange === 'ss'">&spades;</span>
    <span v-else-if="suitsOfSpecificHandInRange === 'hh'" class="red">&hearts;</span>
    <span v-else-if="suitsOfSpecificHandInRange === 'dd'" class="red">&diams;</span>

    <!-- offsuit + pairs -->
    <span v-else>
      <span v-if="firstSuitOfSpecificHandInRange === 'c'">&clubs;</span>
      <span v-else-if="firstSuitOfSpecificHandInRange === 's'">&spades;</span>
      <span v-else-if="firstSuitOfSpecificHandInRange === 'h'" class="red">&hearts;</span>
      <span v-else-if="firstSuitOfSpecificHandInRange === 'd'" class="red">&diams;</span><span v-if="secondSuitOfSpecificHandInRange === 'c'">&clubs;</span>
      <span v-else-if="secondSuitOfSpecificHandInRange === 's'">&spades;</span>
      <span v-else-if="secondSuitOfSpecificHandInRange === 'h'" class="red">&hearts;</span>
      <span v-else-if="secondSuitOfSpecificHandInRange === 'd'" class="red">&diams;</span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'grid-square-suits',
  props: ['generalHand'],
  computed: {
    suitsOfSpecificHandInRange: function () {
      let suitsOfSpecificHandInRange = null;

      this.generalHand.forEachPossibleSpecificHand(function (specificHand, specificHandSuits) {
        if (specificHand.inRange) {
          suitsOfSpecificHandInRange = specificHandSuits;
        }
      });

      return suitsOfSpecificHandInRange;
    },
    firstSuitOfSpecificHandInRange: function () {
      if (this.suitsOfSpecificHandInRange) {
        return this.suitsOfSpecificHandInRange[0];
      }

      return null;
    },
    secondSuitOfSpecificHandInRange: function () {
      if (this.suitsOfSpecificHandInRange) {
        return this.suitsOfSpecificHandInRange[1];
      }

      return null;
    },
    numSpecificHandsInRangeVisbile: function () {
      return this.$store.state.account.user.settings.general.visual.areNumCombosInRangeVisible === true;
    },
  },
};
</script>

<style lang="scss" scoped>
  .red {
    color: red;
  }

  .more-than-one-text {
    font-size: 8px;
    position: relative;
    bottom: 1px;
    color: grey;
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/grid-selector/grid-square-suits.vue